import { SocialSharing } from '@change/ds-core-ui/next';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { useI18n } from '@change-corgi/core/react/i18n';

import { useSocialIconWithSuccessState } from './hooks/useSocialIconWithSuccessState';

type Props = {
	action: () => Promise<boolean>;
	icon: React.ReactElement;
	label: TranslationKey;
	successLabel?: TranslationKey;
	variant?: 'default' | 'facebook' | 'instagram' | 'twitter' | 'whatsapp' | 'facebookMessenger' | 'nextdoor' | 'reddit';
	size?: 'x-small' | 'small' | 'medium' | 'large' | 'x-large';
} & Omit<React.ComponentProps<typeof SocialSharing>, 'label' | 'icon' | 'variant' | 'size' | 'onClick'>;

export type { Props as SocialIconWithSuccessStateProps };

export const SocialIconWithSuccessState = ({
	action,
	icon,
	label,
	successLabel,
	variant = 'default',
	size = 'large',
	...rest
}: Props): React.ReactElement => {
	const { translate } = useI18n();
	const { data, actions } = useSocialIconWithSuccessState({ action, label, successLabel });

	return (
		<SocialSharing
			icon={icon}
			label={translate(data.currentLabel)}
			variant={variant}
			size={size}
			onClick={actions.onClick}
			{...rest}
		/>
	);
};
